import { convertToRoman } from 'helpers/convertToRoman';
import React from 'react';
import { ProgressBarInfo } from '../../../../../GeneralRisk/components/DonutInfo/components/ProgressBarInfo';

import {
	Container,
	HeaderContainer,
	ContentContainer,
	DonutsContainer,
	DescriptionContainer,
} from './MainCard.styles';

interface MainCardProps {
	selectedCommunication: any;
	companyName?: any;
	branchOfficeName?: any;
	sector?: any;
	questionnaire?: any;
}

export const MainCard = ({
	selectedCommunication,
	companyName,
	branchOfficeName,
	sector,
	questionnaire,
}: MainCardProps) => {
	const referenceNumber =
		convertToRoman(Number(selectedCommunication?.sequence) + 1) ?? 'N/A';
	const name = selectedCommunication?.name ?? 'N/A';

	const filtersLabel = [companyName, branchOfficeName, sector].reduce(
		(current, next) => {
			if (current && next) {
				return `${current} - ${next}`;
			}
			if (!current && next) {
				return next;
			}
			if (current && !next) {
				return current;
			}
		},
		'',
	);

	const percentRound = () => {
		return questionnaire.answers.answered === 0 &&
			questionnaire.answers.total === 0
			? 0
			: Math.round(
					(questionnaire.answers.answered / questionnaire.answers.total) * 100,
			  );
	};

	return (
		<Container>
			<HeaderContainer>
				<h3>{`Guía de referencia ${referenceNumber} - ${name}`}</h3>
				<p>{filtersLabel}</p>
			</HeaderContainer>
			<ContentContainer>
				<DonutsContainer>
					<ProgressBarInfo
						percent={percentRound()}
						color="#8FEA57"
						description="Evaluaciones completadas"
						answered={questionnaire.answers.answered}
						total={questionnaire.answers.total}
					/>
					<ProgressBarInfo
						labelText={questionnaire.risk.name}
						title={questionnaire.risk.name}
						color={questionnaire.risk.color}
						percent={100}
						description="Nivel de riesgo general "
					/>
				</DonutsContainer>
				<DescriptionContainer>
					<h2>Toma de acciónes: </h2>
					<p>
						<b>{questionnaire.risk.name}</b>
						{` ${questionnaire.risk.action}`}
					</p>
				</DescriptionContainer>
			</ContentContainer>
		</Container>
	);
};
